import { Helmet } from 'react-helmet-async';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Grid } from '@mui/material';
import { InvoicingView } from '../../../components/dashboard/invoicing';
import { useDispatch, useSelector } from '../../../redux/store';
import CustomToolbar from '../../../components/dashboard/invoicing/CustomToolbar';
import {
  clearViewedInvoiceIds,
  getInvoiceDataFromRedux,
  getInvoices,
  getInvoicesInParsing,
  getBookingSubmitSchedules,
} from '../../../redux/slices/invoicing';
import CompletedInvoices from '../../../components/dashboard/invoicing/CompletedInvoices';

export default function NewInvoicing() {
  const location = useLocation();
  const section = location.pathname.split('/').pop();
  const dispatch = useDispatch();

  const {
    data: { invoicesInParsingProgress, invoiceData, viewedInvoiceIds, manualInvoicing, pendingInvoicing },
  } = useSelector((state) => state.invoicing);
  const [showSelection, setShowSelection] = useState('');
  const [selectedToProcess, setSelectedToProcess] = useState([]);
  const [localIsLoading, setLocalIsLoading] = useState(true);
  const [openInvoiceUploader, setOpenInvoiceUploader] = useState(false);

  useEffect(() => {
    const manualIds = new Set(manualInvoicing.map((inv) => inv.id));
    let interval;

    const shouldPoll = invoicesInParsingProgress && invoicesInParsingProgress.length > 0;

    if (shouldPoll) {
      const missingNewIds = invoicesInParsingProgress.filter((id) => !manualIds.has(id));
      if (missingNewIds.length > 0) dispatch(getInvoices(null, missingNewIds));
      interval = setInterval(
        () => {
          dispatch(getInvoicesInParsing());
        },
        invoicesInParsingProgress.length > 100 ? 600000 : 9000
      );
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [dispatch, invoicesInParsingProgress]);

  useEffect(() => {
    if (viewedInvoiceIds.length > 0 && pendingInvoicing.length > 0) {
      dispatch(getInvoices(null, viewedInvoiceIds)).then(() => setLocalIsLoading(false));
    } else dispatch(getInvoices()).then(() => setLocalIsLoading(false));
    dispatch(getBookingSubmitSchedules());
    dispatch(clearViewedInvoiceIds());
  }, []);

  useEffect(() => {
    if (!localIsLoading) {
      if (section === 'new') dispatch(getInvoicesInParsing());
      if (invoiceData.vendors.length === 0) dispatch(getInvoiceDataFromRedux()); //Get vendors for upload invoice PDF
    }
  }, [section, localIsLoading]);

  const [activeRows, setActiveRows] = useState([]);
  const customToolbar = useCallback(() => {
    const isFiltered = (filter) => filter === section;
    return (
      <CustomToolbar
        isFiltered={isFiltered}
        activeRows={activeRows}
        showSelection={showSelection}
        setShowSelection={setShowSelection}
        setSelectedToProcess={setSelectedToProcess}
        openInvoiceUploader={openInvoiceUploader}
        setOpenInvoiceUploader={setOpenInvoiceUploader}
        setIsLoading={setLocalIsLoading}
      />
    );
  }, [activeRows, showSelection, openInvoiceUploader]);

  return (
    <>
      <Helmet>
        <title>Invoicing | Platform Solutions</title>
      </Helmet>
      <Grid item xl={12}>
        <Grid container spacing={3} direction="row" justifyContent="flex-start" alignItems="flex-start">
          {section !== 'previous' && (
            <InvoicingView
              CustomToolbar={customToolbar}
              setActiveRows={setActiveRows}
              showSelection={showSelection}
              setShowSelection={setShowSelection}
              setSelectedToProcess={setSelectedToProcess}
              localIsLoading={localIsLoading}
              openInvoiceUploader={openInvoiceUploader}
              setOpenInvoiceUploader={setOpenInvoiceUploader}
            />
          )}
          {section === 'previous' && <CompletedInvoices CustomToolbar={customToolbar} setActiveRows={setActiveRows} />}
        </Grid>
      </Grid>
    </>
  );
}
